module.exports = __webpack_public_path__ + "static/epoca-negocios-bb1f55c82f707f9f61545cf6ae3d2a88.png";